import React, {useState} from 'react';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';


export default function SnackbarControls(): [React.ReactElement, (m: string) => void] {

    const [open, setOpen] = useState<boolean>(false);
    const [mes, setMes] = useState<string>("");

    const handleClick = (message: string) => {
        setMes(message)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const bar = (
        <Snackbar
            open={open}
            autoHideDuration={5000}
            onClose={handleClose}
            message={mes}
            action={
                <Button color="inherit" onClick={handleClose}>
                    close
                </Button>
            }
        />
    )

    return [bar, handleClick]
}